import React from 'react';
import { LoadingButton } from "@mui/lab";
import { makeStyles } from "@mui/styles";
import { SxProps } from "@mui/material";

const SubmitButton: React.FC<SubmitButtonProps> = props => {
    const styles = useStyles();

    return (
        <LoadingButton
            loadingPosition='center'
            loading={ props.isLoading }
            type={ props.type || 'submit' }
            className={ styles.root }
            disabled={ props.isLoading || props.disabled }
            onClick={ props.onClick }
            sx={ {
                height: 'fit-content',
                ...props.sx,
            } }
            size={ props.size }
            classes={ { root: props.className } }
        >
            &nbsp;{ !props.isLoading && (props.children || props.text || 'Zapisz') }&nbsp;
        </LoadingButton>
    );
}
export default SubmitButton;

export interface SubmitButtonProps {
    readonly isLoading?: boolean;
    readonly text?: string;
    readonly disabled?: boolean;
    readonly onClick?: () => void;
    readonly sx?: SxProps;
    readonly children?: any;
    readonly type?: 'submit' | 'button' | 'reset';
    readonly size?: 'small' | 'medium' | 'large';
    readonly className?: string;
}


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: '110px !important',
        backgroundColor: theme.palette.secondary.main + ' !important',
        color: theme.palette.secondary.contrastText + ' !important',
        '&:disabled': {
            backgroundColor: theme.palette.secondary.dark + ' !important',
        }
    },
}))